import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from 'src/app/helpers/modal.tokens';

@Component({
  selector: 'app-project-team-drill-down-modal',
  templateUrl: './project-team-drill-down-modal.component.html',
  styleUrls: ['./project-team-drill-down-modal.component.scss']
})
export class ProjectTeamDrillDownModalComponent implements OnInit {

  constructor(
    @Inject(MODAL_DATA) public data: any,
    private dialogRef: MatDialogRef<any>) { }
  
  ngOnInit(): void {
  }

  close(result: any) {
    this.dialogRef.close(result);
  }

}
